module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("lDU2X"))).then(() => parcelRequire('37nVf'));